/**
 * The portal's one date renderer.
 *
 * A bare YYYY-MM-DD parses as UTC midnight, and every US timezone reads
 * that as the evening before: rendered locally, a hearing on the 15th
 * reaches the client as the 14th. Values that carry a real time of day
 * (an upload, a payment webhook) still render in the reader's zone.
 */
export function formatPortalDate(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const opts: Intl.DateTimeFormatOptions = { month: "long", day: "numeric", year: "numeric" };
  if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) opts.timeZone = "UTC";
  return d.toLocaleDateString("en-US", opts);
}
